import { highlightBracketedText } from 'src/utils/utils';
import { AccordionFieldsFragment } from 'src/generated/graphql';
import DynamicMedia from 'src/components/shared/DynamicMedia';
import { highlightUnderscoreText } from 'src/utils/utils';

type NewsComponentProps = {
  content?: AccordionFieldsFragment;
  className?: string;
};

const PartnerCard = ({ content, className="" }: NewsComponentProps) => {
  if (!content) {
    return null;
  }

  const { title, accordionItemsCollection, backgroundImage, image, descriptionJson  } = content;
  const items = accordionItemsCollection?.items || [];

  const titleLines = title?.split('..').map(line => line.trim()) || [];

  const descriptionText =
    descriptionJson?.json?.content
      ?.map((block: any) =>
        block?.content?.map((c: any) => c?.value || '').join(' ')
      )
      .join('\n') || '';

  return (
    <div
      className={`partner-card ${className}`}
      style={
        backgroundImage?.url
          ? { backgroundImage: `url(${backgroundImage.url})` }
          : undefined
      }
    >
      <div className="partner-card__content">
        <div className="partner-card__title partner-card__title--text">
          {titleLines.map((line, index) => (
            <h2
              key={index}
              className={`title-line title-line--${index + 1}`}
              dangerouslySetInnerHTML={{
                __html: highlightBracketedText(line ?? '', 'bold'),
              }}
            />
          ))}
        </div>
        <div className="partner-card__layout">
          <div className="partner-card__image">
            {className?.includes('workload-card') || className?.includes('works-card') ? (
              <DynamicMedia
                src={image?.url ?? ''}
                alt={image?.title ?? ''}
                ariaLabel={image?.title ?? ''}
                lottieProps={{
                  loop: true,
                }}
              />
            ) : (
              <img src={image?.url ?? ''} alt={image?.title ?? ''} />
            )}
          </div>

          <div className="partner-card__features">

            {className?.includes('task-workload-card') && (
              <div className="partner-card__title">
                {titleLines.map((line, index) => (
                  <h2
                    key={index}
                    className={`title-line title-line--${index + 1}`}
                    dangerouslySetInnerHTML={{
                      __html: highlightBracketedText(line ?? '', 'bold'),
                    }}
                  />
                ))}
                {descriptionText && (
                  <p
                                className="feature-card__description-main"
                                dangerouslySetInnerHTML={{
                                  __html: highlightUnderscoreText(
                                    (descriptionText ?? '')
                                      .replace(/\\n/g, '<br/>')
                                      .replace(/\/n/g, '<br/>')
                                      .replace(/\n/g, '<br/>'),
                                  ),
                                }}
                              />
                )}
              </div>
            )}
            {items?.map((item, index) =>
              className?.includes('works-card') ? (
                <div className="feature-item" key={index}>
                  <div className="feature-item-number">
                    <h2 className="number mb-0">{index + 1}</h2>
                  </div>
                  <div className="feature-item-partner">
                    <h3 className="feature-item-partner__title font-medium">{item?.itemText}</h3>
                    <p className="feature-item-partner__description light">
                      {item?.additionalItemText}
                    </p>
                  </div>
                </div>
              ) : (
                <div key={index} className="feature-item-partner">
                  <h3
                    className="feature-item-partner__title font-medium"
                    style={{ color: '#FFFFFF' }}
                  >
                    {item?.itemText}
                  </h3>
                  <p
                    className="feature-item-partner__description light"
                    style={{ color: '#FFFFFF' }}
                  >
                    {item?.additionalItemText}
                  </p>
                </div>
              ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerCard;
